<bp-content class="full-height">
  @if (showWalletDetails()) {
    <div class="wallet-details-header">
      @if (!isIframeMode) {
        <div class="wallet-details-header__links container-left-right">
          <div>
            <a
              class="wallet-details-header__links__link"
              [routerLink]="['/portfolio']"
              [queryParams]="{ type: assetType }">
              <span class="bpi__icon-caret-left"></span>
              <span class="font-size-15 pl-15">{{ "portfolio_overview_button_text" | translate }}</span>
            </a>
          </div>
          <div>
            @if (hasQRCodeDetails()) {
              <a
                class="wallet-details-header__links__link wallet-details-header__links__details"
                [routerLink]="['/fiat-wallet-details', walletId]">
                {{ "wallet_deposit_details" | translate }}
              </a>
            }
          </div>
        </div>
      }
      @if (!isIframeMode) {
      <div class="wallet-details-header__masthead">
        <div class="wallet-details-header__masthead__title">
          <span
						class="wallet-details-header__masthead__title__currency-symbol bpi__icon-{{
							getCurrency()?.getSymbol(true)
						}}"></span>
          {{ fiatName(getCurrency()) }} {{ "wallet" | translate }}
        </div>
        <div class="wallet-details-header__masthead__amount">
          @if (cashPlusViewModel$ | async; as vm) {
            <!--	To be able to handle error from different end-points, multiple ng-container as the follow have to be in place   -->
            @if (vm.isConfigurationLoaded) {
              @if (vm.isFiatEligible) {
                @if (vm.portfolioState) {
                  <div class="wallet-details-header__masthead__amount__actual">
                    {{
                    vm?.portfolioState?.asset_balance
                    | fiat_precision_symbol
                    : { id: getCurrency().getId(), currencies: [getCurrency()] }
                    }}
                  </div>
                  <!-- fiat wallet amount in EUR -->
                  @if (d_fiat?.getId() !== getCurrency()?.getId()) {
                    <span
                      class="wallet-details-header__masthead__amount__exchanged"
                      >
                      {{
                      (vm?.portfolioState?.asset_balance * getCurrency()?.toEuroRate()) /
                      d_fiat?.toEuroRate()
                      | fiat_precision_symbol: { id: d_fiat?.getId(), currencies: [d_fiat] }
                      }}
                    </span>
                  }
                } @else {
                  <div class="error">
                    {{ "portfolio_load_error" | translate }}
                  </div>
                }
              } @else {
                <div class="wallet-details-header__masthead__amount__actual">
                  {{
                  getWallet()?.getBalance()
                  | fiat_precision_symbol: { id: getCurrency().getId(), currencies: [getCurrency()] }
                  }}
                </div>
                <!-- fiat wallet amount in EUR -->
                @if (d_fiat?.getId() !== getCurrency()?.getId()) {
                  <span
                    class="wallet-details-header__masthead__amount__exchanged"
                    >
                    {{
                    (getWallet()?.getBalance() * getCurrency()?.toEuroRate()) / d_fiat?.toEuroRate()
                    | fiat_precision_symbol: { id: d_fiat?.getId(), currencies: [d_fiat] }
                    }}
                  </span>
                }
              }
            } @else {
              <div class="error">
                {{ "portfolio_load_error" | translate }}
              </div>
            }
          } @else {
            <div class="wallet-details-header__masthead__amount__actual">
              {{
              getWallet()?.getBalance()
              | fiat_precision_symbol: { id: getCurrency().getId(), currencies: [getCurrency()] }
              }}
            </div>
            <!-- fiat wallet amount in EUR -->
            @if (d_fiat?.getId() !== getCurrency()?.getId()) {
              <span
                class="wallet-details-header__masthead__amount__exchanged"
                >
                {{
                (getWallet()?.getBalance() * getCurrency()?.toEuroRate()) / d_fiat?.toEuroRate()
                | fiat_precision_symbol: { id: d_fiat?.getId(), currencies: [d_fiat] }
                }}
              </span>
            }
          }
        </div>
      </div>
      <!--CASH PLUS WIDGET-->
      @if (cashPlusViewModel$ | async; as vm) {
        @if (vm.subsState.subscribed || vm.portfolioState?.reserved_asset_balance > 0) {
          <div class="wallet-balance-details">
            @if (vm.portfolioState?.reserved_asset_balance > 0) {
              <div class="wallet-balance-details__item">
                <div class="wallet-balance-details__item__title">{{ "reserved_funds" | translate }}</div>
                <div class="wallet-balance-details__item__amount">
                  {{
                  +vm.portfolioState?.reserved_asset_balance
                  | fiat_precision_symbol
                  : {
                  id: getCurrency().getId(),
                  symbol: false
                }
                }}
              </div>
            </div>
          }
          @if (vm.portfolioState?.reserved_asset_balance > 0) {
            <div class="wallet-balance-details__item wallet-balance-details__item--highlight">
              <div class="wallet-balance-details__item__title">{{ "funds_available" | translate }}</div>
              <div class="wallet-balance-details__item__amount">
                {{
                +vm.portfolioState?.usable_asset_balance
                | fiat_precision_symbol
                : {
                id: getCurrency().getId(),
                symbol: false
              }
              }}
            </div>
          </div>
        }
        @if (vm.subsState.subscribed) {
          <div class="wallet-balance-details__item" [ngClass]="{ 'wallet-balance-details__item--indent': vm.portfolioState?.reserved_asset_balance > 0 }">
            <div class="wallet-balance-details__item__title">{{ "cash_plus_cash_balance" | translate }}</div>
            <div class="wallet-balance-details__item__amount">
              <bp-icon class="midnight-roll-info" icon="info" size="24" theme="regular" (click)="openInfoModal('info_roll')">
              </bp-icon>
              <bp-pill-info>{{ "cash_plus_rolls_on_working_days" | translate }}</bp-pill-info>
              {{
              +vm.portfolioState?.available_asset_balance
              | fiat_precision_symbol
              : {
              id: getCurrency().getId(),
              symbol: false
            }
            }}
          </div>
        </div>
      }
    </div>
  }
  @if (
    vm.isCashPlusEnabled &&
    vm.isFiatEligible &&
    vm.portfolioState &&
    vm.isSubscriptionLoaded &&
    vm.isConfigurationLoaded
    ) {
    @if (!vm.subsState.subscribed) {
      <div class="dark-surface-v3">
        <bp-general-banner
          [translationKeyPrefix]="'cash_plus_banner'"
          [iconSrc]="'/assets/images/cashplus/earn.svg'"
          (actionClicked)="onClick()"
          [actionBtnType]="'normal'"
          [value]="'' + (vm.configPidState.annual_percentage_rate | percent_symbol)">
        </bp-general-banner>
      </div>
    } @else {
      <cashplus-portfolio-widget
							[ngClass]="{
								'cashplus-widget-disabled': (portfolioState$ | async).isFundReleasePending
							}"
        [cashPlusPortfolio]="vm.portfolioState"
							[currentRate]="
								+vm.configPidState.individual_annual_percentage_rate
									? +vm.configPidState.individual_annual_percentage_rate
									: +vm.configPidState.annual_percentage_rate
							"
        [cashPlusConfig]="vm.configState"
        [currencyId]="getCurrency()?.getId()"
        (optState)="openOptOutModal()"
        (cashOut)="cashOut()"
        (infoState)="openInfoModal($event)">
      </cashplus-portfolio-widget>
    }
  }
}
<!--ACTION BUTTONS-->
<fiat-mobile-action-button-wrapper [wallet]="getWallet()" [alternateFiat]="getCurrency()">
</fiat-mobile-action-button-wrapper>
<!---->
}
<div class="wallet-details-header__filters">
  <div class="bp-wrapper">
    <a
      class="filter-button btn btn-sm"
      [ngClass]="{ 'is-active': noFilter() }"
      (click)="clearFilter()"
      (keydown.enter)="clearFilter()"
      [tabIndex]="0">
      {{ "show_all" | translate }}
    </a>
    <a
      class="filter-button btn btn-sm"
						[ngClass]="{
							'is-active': isType('pending', 'public_status')
						}"
      (click)="filter('pending', 'public_status')"
      (keydown.enter)="filter('pending', 'status')"
      [tabIndex]="0">
      {{ "filter-button-pending" | translate }}
    </a>
    @for (type of getFilters(); track type) {
      <a
        class="filter-button btn btn-sm"
        [ngClass]="{ 'is-active': isType(type) }"
        (click)="filter(type)"
        (keydown.enter)="filter(type)"
        [tabIndex]="0">
        {{ "filter-button-" + type | translate }}
      </a>
    }
  </div>
</div>
</div>
}
<div class="wallet-details-body center-block of-tnum">
  @for (keys of getMapKeys(map); track keys) {
    <div class="transactions-list">
      <div class="transactions-list-separator">
        <span>{{ keys }}</span>
      </div>
      @for (transaction of map?.get(keys); track transaction) {
        <fiat-transaction-list-item
          [transaction]="transaction"
          [focusable]="true"
          class="card-interactive">
        </fiat-transaction-list-item>
      }
    </div>
  }
  @if (map?.size === 0) {
    <empty [headline]="'wallet_detail_no_transactions_made' | translate" [textLight]="true">
    </empty>
  }
  <bp-pagination [ngClass]="'pagination-wrapper'"></bp-pagination>
</div>
</bp-content>
